const FileUploadMapping={"too-many-files":"helpspoke.upload.errors.too_many_files","file-too-large":"helpspoke.upload.errors.file_too_large","file-invalid-type":"helpspoke.upload.errors.file_invalid_type"};

export { FileUploadMapping };
//# sourceMappingURL=FileUploadMapping.js.map
